import type { FaireProductEntity } from "../../entity_types/product";

export const p_6vjngs9b7t: FaireProductEntity = {
  token: "p_6vjngs9b7t",
  type: "product",
  name: "Split Dip Earrings",
  brandToken: "b_985aneiq",
  brandName: "Twenty Two West",
  imageUrl:
    "https://cdn.faire.com/fastly/d06e025063b7b389565a1c245da457b91f56990d33378ec2dc4a3425e68b59c5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/413e97dd63952226d22ce0073422677221630fe4e19ace0a1b5b28e6ba62c9b1.jpeg",
    "https://cdn.faire.com/fastly/2baffab9363b512dd972412e85842add2d98384844f14fb661a3b8961a4ec389.jpeg",
  ],
  priceDollars: 24,
  description:
    'Say hello to the Split Dip Earrings! These slender porcelain earrings feature a playful split at the top creating the perfect sence of movement. Bright, bold color pairs beautifully with the rich white of the porcelain, a visual nod to those essential cool-off moments on warmer days. Tiny hints of color peek from the sides, offering a sweet little surprise with every move you make.\n\nThese earrings are made for playful days.\n\nDETAILS\n\no Measures: 1 1/2" x 3/8"\n\no Materials: porcelain, sterling silver post',
  tags: [],
  msrpDollars: 48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:37:40.818Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
